export enum IconNamesEnum {
  Apple = 'apple',
  ArrowDown = 'arrow-down',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowUp = 'arrow-up',
  Basket = 'basket',
  BellAlt = 'bell-alt',
  CalendarPen = 'calendar-pen',
  Camera = 'camera',
  Card = 'card',
  CheckFalseHoverFalsePressedFalseDisabledFalse = 'check-false-hover-false-pressed-false-disabled-false',
  CheckFalseHoverFalsePressedFalseDisabledTrue = 'check-false-hover-false-pressed-false-disabled-true',
  CheckFalseHoverFalsePressedTrueDisabledFalse = 'check-false-hover-false-pressed-true-disabled-false',
  CheckFalseHoverTruePressedFalseDisabledFalse = 'check-false-hover-true-pressed-false-disabled-false',
  CheckTrueHoverFalsePressedFalseDisabledFalse = 'check-true-hover-false-pressed-false-disabled-false',
  CheckTrueHoverFalsePressedFalseDisabledTrue = 'check-true-hover-false-pressed-false-disabled-true',
  CheckTrueHoverFalsePressedTrueDisabledFalse = 'check-true-hover-false-pressed-true-disabled-false',
  CheckTrueHoverTruePressedFalseDisabledFalse = 'check-true-hover-true-pressed-false-disabled-false',
  Check = 'check',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  CircleQuestion = 'circle-question',
  Cloche = 'cloche',
  Clock = 'clock',
  CloseSmall = 'close-small',
  Close = 'close',
  Coins = 'coins',
  Crosshair = 'crosshair',
  Delete = 'delete',
  Download = 'download',
  FileList = 'file-list',
  HomeFilledFalse = 'home-filled-false',
  HomeFilledTrue = 'home-filled-true',
  Information = 'information',
  Kakao = 'kakao',
  LocationFilledFalse = 'location-filled-false',
  LocationFilledTrue = 'location-filled-true',
  Minus = 'minus',
  OrderListFilledFalse = 'order-list-filled-false',
  OrderListFilledTrue = 'order-list-filled-true',
  Pen = 'pen',
  Phone = 'phone',
  Plus = 'plus',
  QrScan = 'qr-scan',
  RadioFalseHoverFalsePressedFalseDisabledFalse = 'radio-false-hover-false-pressed-false-disabled-false',
  RadioFalseHoverFalsePressedFalseDisabledTrue = 'radio-false-hover-false-pressed-false-disabled-true',
  RadioFalseHoverFalsePressedTrueDisabledFalse = 'radio-false-hover-false-pressed-true-disabled-false',
  RadioFalseHoverTruePressedFalseDisabledFalse = 'radio-false-hover-true-pressed-false-disabled-false',
  RadioTrueHoverFalsePressedFalseDisabledFalse = 'radio-true-hover-false-pressed-false-disabled-false',
  RadioTrueHoverFalsePressedFalseDisabledTrue = 'radio-true-hover-false-pressed-false-disabled-true',
  RadioTrueHoverFalsePressedTrueDisabledFalse = 'radio-true-hover-false-pressed-true-disabled-false',
  RadioTrueHoverTruePressedFalseDisabledFalse = 'radio-true-hover-true-pressed-false-disabled-false',
  RefreshAll = 'refresh-all',
  Refresh = 'refresh',
  RoundCheckFalseHoverFalsePressedFalseDisabledFalse = 'round-check-false-hover-false-pressed-false-disabled-false',
  RoundCheckFalseHoverFalsePressedFalseDisabledTrue = 'round-check-false-hover-false-pressed-false-disabled-true',
  RoundCheckFalseHoverFalsePressedTrueDisabledFalse = 'round-check-false-hover-false-pressed-true-disabled-false',
  RoundCheckFalseHoverTruePressedFalseDisabledFalse = 'round-check-false-hover-true-pressed-false-disabled-false',
  RoundCheckTrueHoverFalsePressedFalseDisabledFalse = 'round-check-true-hover-false-pressed-false-disabled-false',
  RoundCheckTrueHoverFalsePressedFalseDisabledTrue = 'round-check-true-hover-false-pressed-false-disabled-true',
  RoundCheckTrueHoverFalsePressedTrueDisabledFalse = 'round-check-true-hover-false-pressed-true-disabled-false',
  RoundCheckTrueHoverTruePressedFalseDisabledFalse = 'round-check-true-hover-true-pressed-false-disabled-false',
  Search = 'search',
  SmileFilledFalse = 'smile-filled-false',
  SmileFilledTrue = 'smile-filled-true',
  SwitchVertical = 'switch-vertical',
  Trash = 'trash',
  UnionThreeBar = 'union-three-bar'
}
